import { render, staticRenderFns } from "./AnnotationComponent.vue?vue&type=template&id=118e9382&scoped=true&"
import script from "./AnnotationComponent.vue?vue&type=script&lang=js&"
export * from "./AnnotationComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationComponent.vue?vue&type=style&index=0&id=118e9382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e9382",
  null
  
)

export default component.exports